/* unplugin-vue-components disabled */import { render } from "./Login4.vue?vue&type=template&id=68fd76eb&scoped=true"
import script from "./Login4.vue?vue&type=script&lang=js"
export * from "./Login4.vue?vue&type=script&lang=js"

import "./Login4.vue?vue&type=style&index=0&id=68fd76eb&lang=less&scoped=true"
import "./Login4.vue?vue&type=style&index=1&id=68fd76eb&lang=less"

import exportComponent from "D:\\云盘\\SynologyDrive\\Synology Drive\\文件\\客户调查表\\customweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fd76eb"]])

export default __exports__